import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import {
    addAndApplyFilter,
    clearFiltersByName,
    updateUriRef,
} from '../../../actions/filterActions';

// components
import { SbSharedRefineMenuInputRadio } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputRadio';

// Used just for identifying the `all` value, should never be set in the filter store.
function getAllUrlLabel(filterName) {
    return `all ${filterName}`;
}

const { all } = defineMessages({
    all: {
        id: 'sb.SbMobileRefineMenu.radioSelect.all',
        defaultMessage: `{filterName, select,
            location {Anywhere}
            categoryL2 {All {allLabel}}
            categoryL3 {All {allLabel}}
            categoryL4 {All {allLabel}}
            other {All}
        }`,
    },
});

function SbSharedRefineMenuRadioSelectComponent(props) {
    const {
        appliedFilterValues,
        valuesToShow,
        filterName,
        intl,
        displayUriRef,
        canBeDismissed,
        allLabel,
        totalCount,
    } = props;
    const allUrlLabel = getAllUrlLabel(filterName);
    const appliedUrlLabel = get(appliedFilterValues, '0.urlLabel') || allUrlLabel;
    const valuesToShowCopy = [...valuesToShow];

    if (canBeDismissed && valuesToShow.length > 1) {
        valuesToShowCopy.unshift({
            displayName: intl.formatMessage(all, { filterName, allLabel }),
            urlLabel: allUrlLabel,
            count: totalCount || 0,
            link: displayUriRef,
        });
    }

    return (
        <div>
            {valuesToShowCopy.map(item => {
                return (
                    <SbSharedRefineMenuInputRadio
                        key={item.urlLabel}
                        value={item.urlLabel}
                        checked={item.urlLabel === appliedUrlLabel}
                        seoLink={item.link}
                        onChange={() => props.onChange(item)}
                        text={item.displayName}
                        count={item.count}
                        isHidden={item.isHidden}
                    />
                );
            })}
        </div>
    );
}

SbSharedRefineMenuRadioSelectComponent.propTypes = {
    appliedFilterValues: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    displayUriRef: PropTypes.string.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    canBeDismissed: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    allLabel: PropTypes.string,
    totalCount: PropTypes.number,
};

function mapDispatchToProps(dispatch, props) {
    return {
        onChange(item) {
            dispatch(clearFiltersByName(props.filterName));
            if (item.urlLabel !== getAllUrlLabel(props.filterName)) {
                dispatch(addAndApplyFilter(props.filterName, item));
            } else {
                dispatch(updateUriRef());
            }
        },
    };
}

export const SbSharedRefineMenuRadioSelect = connect(
    null,
    mapDispatchToProps
)(injectIntl(SbSharedRefineMenuRadioSelectComponent));
